<template>
    <div>
			<!--面包屑导航区域-->
            <div class="crumbs">
            	<el-breadcrumb separator="/">
				<el-breadcrumb-item>
              <i class="el-icon-school"></i> 绘本分类
			  </el-breadcrumb-item>
            </el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query" >
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								
								<el-select  v-model="query.sort" clearable :placeholder="'请选择分类'" class="select-shop mr10">
									<el-option v-for="item in query.optionsSORT" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select>
								
								<el-input v-model="query.name" clearable :placeholder="'请输入名称'" class="handle-input mr10" style="width: 15%;"></el-input>

								
								<!-- <el-select v-model="query.stat" clearable :placeholder="'请选择删除状态'" class="select-shop mr10">
									<el-option v-for="item in query.optionsStat" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select> -->
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button  type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"@click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!-- <el-button type="success" :disabled="!hasPerms(buttonPerms.batchrelationPerms)" icon="el-icon-connection" @click="delAllRelation">批量关联</el-button> -->
							</div>
						</el-col>
						<el-col :span="2" style="text-align: right;">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.addPerms)" icon="el-icon-plus" @click="handleAdd">添加分类</el-button>
						</el-col>
					</el-row>
				</div>

				<el-table :data="tableData" border class="table" 
				 header-cell-class-name="table-header" :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
					<el-table-column prop="INIDISP" :label="'分类'"align="center" ></el-table-column>
					<el-table-column prop="MTPNAME" :label="'名称'" align="center"></el-table-column>
					
					<el-table-column :label="'操作'" width="200" align="center" class="without-outline">
						<template slot-scope="scope">
							<el-button type="text" :disabled="!hasPerms(buttonPerms.editPerms)" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
							<el-button type="text" :disabled="!hasPerms(buttonPerms.deletePerms)"  style="color: red;"  icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper ,sizes" :current-page="this.query.pageIndex"
					 :page-sizes="[10, 50,100]"   :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
			<el-dialog :title="sID==''?'添加绘本分类':'修改绘本分类'" width="40%" v-if="showLOG"
			:visible.sync="showLOG" :close-on-click-modal="false">
				<el-form :model="ruleForm" :rules="dataRule" ref="ruleForm"  label-width="100px">
					<el-form-item  :label="'分类：'" prop="SORT">
						<el-select  v-model="ruleForm.SORT" clearable :placeholder="'请选择分类'"  :disabled="visible" >
							<el-option v-for="item in ruleForm.optionsSORT" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item  :label="'名称：'" prop="NAME">
						<el-input v-model="ruleForm.NAME" clearable  maxlength="20"  :placeholder="'请输入名称'" style="width: 300px;" ></el-input>
					</el-form-item>
				</el-form>
				
				<span slot="footer" class="dialog-footer">
					<el-button  @click="showLOG = false">关闭</el-button>
					<el-button  type="primary" @click="submit('ruleForm')">保存</el-button>
				</span>
			</el-dialog>
		</div>
		

		
		
    </div>
</template>

<script>
	import {
			hasPermission
		} from '@/permission/index.js'
		export default {
			name: 'typeList',
			inject: ['reload'], //在子组件中通过inject调用
			data() {
				return {
					//页面按钮权限
					buttonPerms: {
						addPerms: 'book:typeList:add', //新增权限标识
						searchPerms: 'book:typeList:search', //搜索权限标识
						editPerms: 'book:typeList:edit', //编辑权限标识
						// editYCJEPerms: 'garden:gardenList:editYCJE', //编辑权限标识
						deletePerms: 'book:typeList:delete', //删除权限标识
						batchdelPerms: 'book:typeList:batchdel', //批量删除权限标识
						batchrelationPerms: 'book:typeList:batchrelation', //批量删除权限标识
						editHBFYPerms:'book:typeList:editHBFY',
						disabled: false
					},
					
					web_suuid: sessionStorage.getItem("ms_web_suuid"), 
					web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
					roleFlag:false,
					showLOG:false,
					nameFLAG:false,
					
					sID:'',
					
					query: {
						optionsSORT: '',
						name: '',
						sort: '',
						pageIndex: 1, //当前页
						pageSize: 10 //这是当前每页显示的条数
					},
					ruleForm:{
						SORT:'',
						NAME:'',
						optionsSORT:[],
						
					},
					tableData: [],
					visible:false,
					
					multipleSelection: [], // 多选操作
					delList: [],
					pageTotal: 0, // 总条数
					loading: false,
					dataRule: {
						SORT:[{
							required: true,
							message: '请选择分类',
							trigger: ['blur', 'change'],
						}],
						NAME:[{
							required:true,
							trigger: ['blur', 'change'],
							message: '请输入名称',
						}]
					},
				};
			},
			created() {
				let curpagenum = this.query.pageIndex; //当前页码
				this.sID=''
				this.getData(curpagenum); //获取当前列表数据
				this.get_MTP_List_Count(); //获取当前列表条数
				this.getINI();
			},
			mounted() {
				this.$bus.$on('change', () => {
					//刷新当前页面
					this.reload()
				})
			},
			methods:{
				
				hasPerms: function(perms) {
					// 根据权限标识和外部指示状态进行权限判断
					return hasPermission(perms) & !this.buttonPerms.disabled
				},
				// 获取当前列表条数
				get_MTP_List_Count() {
					const self_count = this;
					var postUrl = 'WCF/WEB/svcMTP.svc/GetMTPListCount';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sNAME: self_count.query.name,
								sSORT: self_count.query.sort,
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							this.pageTotal = Number(resCount); //总条数
						})
						.catch((error) => {
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				},
				// 获取幼儿园数据
				getData(curpage) {
					this.loading = true; //初始化加载loading效果
					const self_count = this;
					var postUrl = 'WCF/WEB/svcMTP.svc/GetMTPList';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sNAME: self_count.query.name,
								sSORT: self_count.query.sort,
								sPageIndex: curpage, //页码
								sPageSize: self_count.query.pageSize //每页显示条数
						
							})
						.then((response) => {
							this.loading = false; //取消loading效果
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							//console.log(resCount);
							let resKKDT = response.data.KKDT;
							//console.log(resKKDT);
							if (resCount > 0) {
								
								//渲染数据 List
								this.tableData = resKKDT; //数据数组
							} else {
								this.tableData = []; //数据数组
							}
						})
						.catch((error) => {
							this.loading = false; //取消loading效果
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				
				},
				
				getINI() {
					const self_count = this;
					var postUrl = 'WCF/Public/svcPublic.svc/Get_INI_KEY1';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sKEY1:'10025'
							})
						.then((response) => {
							
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							//console.log(resCount);
							let resKKDT = response.data.KKDT;
							//console.log(resKKDT);
							if (resCount > 0) {
								
								//渲染数据 List
								this.query.optionsSORT = resKKDT; //数据数组
								this.ruleForm.optionsSORT= resKKDT; //数据数组
							} else {
								this.query.optionsSORT = []; //数据数组
								this.ruleForm.optionsSORT=[];
							}
						})
						.catch((error) => {
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				
				},
				// 删除
				handleDelete(index, row) {
					
					// 二次确认删除
					this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
					          confirmButtonText: '确定',
					          cancelButtonText: '取消',
							type: 'warning'
						})
						.then(() => {
							//删除接口
							const self = this;
							var postUrl = 'WCF/WEB/svcMTP.svc/DEL_MTP';
							//网络请求接口
							this.$axios.post(
									//请求的url
									postUrl,
									//请求参数
									{
										sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
										sID: row.MTPMSID ,//uid
										sSORT:row.MTPSORT
									}
								)
								.then((response) => {
									//请求成功返回的数据
									let resStatus = response.status; //200 代表请求成功
									let resKKSTR = response.data.KKSTR;
				
									if (resStatus == "200") {
										if (resKKSTR == "N") {
											this.$message({
												message: '数据删除失败', //删除失败
												type: 'error'
											});
										} else if (resKKSTR == "Y") {
											this.$message.success('数据删除成功'); //删除成功
											this.tableData.splice(index, 1);
				
											//刷新当前页面
											this.reload()
										}
									} else {
										this.$message({
											message: '删除请求失败', //请求失败
											type: 'error'
										});
									}
								})
								.catch((error) => {
									this.$message({
										message: '删除请求失败', //请求失败
										type: 'error'
									});
								});
						})
				},
				
			submit(formName){
				this.CHECK_MTP(formName);
			},
				
				SAVE_CHANGE(formName){
					const self = this;
					self.$refs[formName].validate((valid) => {
						if (!valid) {
							self.$message({
								message: '提交失败', //表单验证失败
								type: 'error'
							});
							return;
						}
						//二次确认删除
						self.$confirm('确认提交吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
						
						var postUrl = 'WCF/WEB/svcMTP.svc/SAVE_MTP';
						//网络请求接口
						self.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
								sSORT: self.ruleForm.SORT,
								sNAME: self.ruleForm.NAME,
								sID:self.sID,
								
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;
						
							if (resStatus == "200") {
								if (resKKSTR == "N") {
									self.$message({
										message: '操作失败', //新增失败
										type: 'error'
									});
								} else if (resKKSTR == "Y") {
									self.$message.success('操作成功'); // 操作成功
									self.showLOG = false;
									self.$refs['ruleForm'].resetFields()
									
									if (self.sID!='')
									{
										this.get_MTP_List_Count();
										this.getData(this.query.pageIndex)
									}else{
										self.reload();
									}
								
								}
							} else {
								self.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							}
						})
						.catch((error) => {
							self.$message({
								message: '请求失败', //请求失败
								type: 'error'
							});
						});
					});
					
					});
				},
				
				CHECK_MTP(formName) {
					const self_count = this;
					var postUrl = 'WCF/WEB/svcMTP.svc/CHECK_MTP';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sSORT: self_count.ruleForm.SORT,
								sNAME: self_count.ruleForm.NAME,
								sID:self_count.sID
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;
							if(resKKSTR=='Y')
							{
								this.$confirm('此分类名称已存在', '提示', {
									confirmButtonText: '确定',
								    showCancelButton:false,
									type: 'warning'
								}).then(() => {}).catch(()=>{})
								return;
							
							}else{
								self_count.SAVE_CHANGE(formName)
							}
						})
						.catch((error) => {
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				},
				
				// 触发搜索按钮
				handleSearch() {
					this.$set(this.query, 'pageIndex', 1);
				
					this.getData(1);
					this.get_MTP_List_Count(); //获取当前列表条数
				},
				handleAdd() {
					this.ruleForm.NAME=''
					this.ruleForm.SORT=''
					this.showLOG=true
					this.sID=''
					this.visible=false
				},
				// 编辑操作
				handleEdit(index, row) {
					
					this.ruleForm.NAME=row.MTPNAME
					this.ruleForm.SORT=row.MTPSORT
					this.showLOG=true
					this.sID=row.MTPMSID
					this.visible=true
					//this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload
				},
				// 分页导航 currentPage 改变时会触发
				handlePageChange(currentPage) {
					this.$set(this.query, 'pageIndex', currentPage);
					// 调取列表的函数，初始化时调一次
					this.getData(currentPage);
				},
				//pageSize 改变时会触发
				handleSizeChange(size) {
					this.$set(this.query, 'pageIndex', 1);
					this.$set(this.query, 'pageSize', size);
					// 调取列表的函数，初始化时调一次
					this.getData(1);
				},
				getRowKeys(row) {
					return row.MTPMSID; // id为列表数据的唯一标识
				},
			}
			
}
</script>

<style scoped>
	.without-outline:focus {
	    outline: none;
	}
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
